import type { ComponentProps } from 'react';
import React from 'react';

import { useReorderIfRequired } from '../ReorderingScreen';
import { MenuCollectionScreenContent } from './subcomponents';

// ────────────────────────────────────────────────────────────────────────────────

export const DeliveryMenuCollectionScreen = (
  props: DeliveryMenuCollectionScreenProps,
) => {
  const { restaurantSlug, addressId } = props.route.params;

  useReorderIfRequired(restaurantSlug, addressId);

  return <MenuCollectionScreenContent {...props} />;
};

// ─── Types ──────────────────────────────────────────────────────────────────────

type DeliveryMenuCollectionScreenProps = ComponentProps<
  typeof MenuCollectionScreenContent
>;
